import { SelectableInputField as UnstyledSelectableInputField, withClassName } from '@epages/react-components'

export default withClassName('ep-form-selectable-input')(UnstyledSelectableInputField)
